var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import {} from '@folkjs/dom/ClientRectObserver';
import { css, property, ReactiveElement, state, } from '@folkjs/dom/ReactiveElement';
import { FolkObserver, parseDeepCSSSelector } from './folk-observer';
const folkObserver = new FolkObserver();
// TODO: use mutation observer to track the addition an removal of elements
export class FolkBaseHyperedge extends ReactiveElement {
    constructor() {
        super(...arguments);
        this.#sourcesMap = new Map();
        this.#targetsMap = new Map();
        this.sourceElements = new Set();
        this.targetElements = new Set();
        this.#sourcesCallback = (entry) => {
            this.#sourcesMap.set(entry.target, entry.contentRect);
            this.requestUpdate('sourcesMap');
        };
        this.#targetsCallback = (entry) => {
            this.#targetsMap.set(entry.target, entry.contentRect);
            this.requestUpdate('targetsMap');
        };
    }
    static { this.styles = css `
    :host {
      display: block;
      position: absolute;
      inset: 0;
      pointer-events: none;
    }

    ::slotted(*) {
      pointer-events: auto;
    }
  `; }
    #sourcesMap;
    #targetsMap;
    get sourcesMap() {
        return this.#sourcesMap;
    }
    get targetsMap() {
        return this.#targetsMap;
    }
    get sourceRects() {
        return Array.from(this.#sourcesMap.values());
    }
    get targetRects() {
        return Array.from(this.#targetsMap.values());
    }
    createRenderRoot() {
        const root = super.createRenderRoot();
        return root;
    }
    willUpdate(changedProperties) {
        if (changedProperties.has('sources')) {
            this.#observeSources();
        }
        if (changedProperties.has('targets')) {
            this.#observeTargets();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.unobserveSources();
        this.unobserveTargets();
    }
    #observeSources() {
        const elements = this.sources ? parseDeepCSSSelector(this.sources) : [];
        const elementsMap = new Map(elements);
        const sourceElements = new Set(elements.map((el) => el[0]));
        const elementsToObserve = sourceElements.difference(this.sourceElements);
        const elementsToUnobserve = this.sourceElements.difference(sourceElements);
        this.unobserveSources(elementsToUnobserve);
        for (const el of elementsToObserve) {
            folkObserver.observe(el, this.#sourcesCallback, { iframeSelector: elementsMap.get(el) });
        }
        this.sourceElements = sourceElements;
    }
    #observeTargets() {
        const elements = this.targets ? parseDeepCSSSelector(this.targets) : [];
        const elementsMap = new Map(elements);
        const targetElements = new Set(elements.map((el) => el[0]));
        const elementsToObserve = targetElements.difference(this.targetElements);
        const elementsToUnobserve = this.targetElements.difference(targetElements);
        this.unobserveTargets(elementsToUnobserve);
        for (const el of elementsToObserve) {
            folkObserver.observe(el, this.#targetsCallback, { iframeSelector: elementsMap.get(el) });
        }
        this.targetElements = targetElements;
    }
    #sourcesCallback;
    #targetsCallback;
    unobserveSources(elements = this.sourceElements) {
        for (const el of elements) {
            folkObserver.unobserve(el, this.#sourcesCallback);
            this.#sourcesMap.delete(el);
            this.sourceElements.delete(el);
        }
    }
    unobserveTargets(elements = this.sourceElements) {
        for (const el of elements) {
            folkObserver.unobserve(el, this.#targetsCallback);
            this.#targetsMap.delete(el);
            this.targetElements.delete(el);
        }
    }
}
__decorate([
    property({ reflect: true })
], FolkBaseHyperedge.prototype, "sources", void 0);
__decorate([
    property({ reflect: true })
], FolkBaseHyperedge.prototype, "targets", void 0);
__decorate([
    state()
], FolkBaseHyperedge.prototype, "sourceElements", void 0);
__decorate([
    state()
], FolkBaseHyperedge.prototype, "targetElements", void 0);
//# sourceMappingURL=folk-base-hyperedge.js.map